import script from "./WelcomeNote.vue?vue&type=script&setup=true&lang=js"
export * from "./WelcomeNote.vue?vue&type=script&setup=true&lang=js"

import "./WelcomeNote.vue?vue&type=style&index=0&id=0a6ddf2d&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a6ddf2d"]])

export default __exports__